export default __webpack_public_path__ + "static/media/bj.c9649dbb.svg";